import { useState } from 'react';
import { ChevronDown, AlertTriangle, AlertCircle } from 'lucide-react';

export default function IssueCard({ issue, type = 'writing' }) {
  const [expanded, setExpanded] = useState(false);
  const isWriting = type === 'writing';

  return (
    <div className={`rounded-lg border-l-4 ${isWriting ? 'border-orange-500 bg-orange-50/50' : 'border-yellow-500 bg-yellow-50/50'} p-4`}>
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-start justify-between text-left"
      >
        <div className="flex items-start gap-3">
          {isWriting ? (
            <AlertCircle className="w-5 h-5 text-orange-500 mt-0.5 flex-shrink-0" />
          ) : (
            <AlertTriangle className="w-5 h-5 text-yellow-500 mt-0.5 flex-shrink-0" />
          )}
          <span className="font-medium text-bastion-black">{issue.title}</span>
        </div>
        <ChevronDown className={`w-4 h-4 text-bastion-gray-400 mt-1 flex-shrink-0 transition-transform ${expanded ? 'rotate-180' : ''}`} />
      </button>

      {expanded && (
        <div className="mt-3 ml-8 space-y-2 text-sm">
          <div>
            <span className="font-semibold text-bastion-black">Observation: </span>
            <span className="text-bastion-gray-800">{issue.observation}</span>
          </div>
          <div>
            <span className="font-semibold text-bastion-black">Possible Cause: </span>
            <span className="text-bastion-gray-800">{issue.possibleCause}</span>
          </div>
          <div>
            <span className="font-semibold text-bastion-black">Impact: </span>
            <span className="text-bastion-gray-800">{issue.impact}</span>
          </div>
        </div>
      )}
    </div>
  );
}
